import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (loading) {
    return <div>Loading...</div>;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If no specific roles are required, just check authentication
  if (allowedRoles.length === 0) {
    return children;
  }

  // Check if user's role is in the allowed roles
  if (allowedRoles.includes(user.type)) {
    return children;
  }

  // If user doesn't have the required role, redirect to their appropriate dashboard
  const redirectPath = getUserDashboardPath(user.type);
  return <Navigate to={redirectPath} replace />;
};

const getUserDashboardPath = (userType) => {
  switch (userType) {
    case 'admin':
      return '/admin/dashboard';
    case 'client':
      return '/client/dashboard';
    case 'field_officer':
      return '/field-officer/dashboard';
    default:
      return '/login';
  }
};

export default PrivateRoute;
